import { c as _c } from "react/compiler-runtime";
import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import elements from "./LoginError.module.scss";
import { EffektButton, EffektButtonVariant } from "../../../shared/components/EffektButton/EffektButton";
export type LoginErrorConfig = {
  login_abort_label: string;
  login_button_label: string;
};
export const LoginError: React.FC<{
  message: string;
  siteTitle: string;
  loginErrorConfig: LoginErrorConfig;
}> = t0 => {
  const $ = _c(23);
  const {
    message,
    siteTitle,
    loginErrorConfig
  } = t0;
  const {
    loginWithRedirect,
    logout
  } = useAuth0();
  let t1;
  let t2;
  if ($[0] !== siteTitle) {
    t1 = <h3>{siteTitle}</h3>;
    t2 = <h5>{siteTitle}</h5>;
    $[0] = siteTitle;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== message) {
    t3 = <p>{message}</p>;
    $[3] = message;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== logout) {
    t4 = () => logout({
      logoutParams: {
        returnTo: process.env.NEXT_PUBLIC_SITE_URL
      }
    });
    $[5] = logout;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== loginErrorConfig.login_abort_label || $[8] !== t4) {
    t5 = <EffektButton onClick={t4}>{loginErrorConfig.login_abort_label}</EffektButton>;
    $[7] = loginErrorConfig.login_abort_label;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== loginWithRedirect) {
    t6 = () => loginWithRedirect();
    $[10] = loginWithRedirect;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== loginErrorConfig.login_button_label || $[13] !== t6) {
    t7 = <EffektButton onClick={t6} cy="btn-login" variant={EffektButtonVariant.SECONDARY}>{loginErrorConfig.login_button_label}</EffektButton>;
    $[12] = loginErrorConfig.login_button_label;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t7) {
    t8 = <div className={elements["button-group"]}>{t5}{t7}</div>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t8) {
    t9 = <div className={elements["center-wrapper"]}><div className={elements.content}>{t1}{t2}{t3}{t8}</div></div>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};